import {Elements} from 'react-flow-renderer';
import {PlanElementData} from '../components/plan-element-view';
import {findSmallestRoomContainingPoint, RoomBoundary} from './check-workspace-room-bounds.utility';

export type FloorPoint = {x: number; y: number};

/**
 * Resolve which room occupies a floor-space point using polygon hit-testing.
 * Prefers the smallest containing room when rooms nest / overlap.
 * Falls back to `clickedRoomId` only when no room polygons are available (legacy data).
 */
export const resolveRoomAtPoint = (
  point: FloorPoint,
  roomElements: Elements<PlanElementData>,
  clickedRoomId?: string,
): PlanElementData | null => {
  if (!roomElements?.length) {
    return null;
  }

  const roomBoundaries: RoomBoundary[] = roomElements
    .filter((element) => element.data?.polygon && element.data.polygon.length >= 3)
    .map((element) => ({
      id: element.data.id,
      polygon: element.data.polygon,
    }));

  if (!roomBoundaries.length) {
    if (!clickedRoomId) {
      return null;
    }
    const fallback = roomElements.find(
      (element) => element.data?.id === clickedRoomId || element.id === `rooms-${clickedRoomId}`,
    );
    return fallback?.data ?? null;
  }

  const match = findSmallestRoomContainingPoint(point, roomBoundaries);
  if (!match?.id) {
    return null;
  }

  const roomElement = roomElements.find(
    (element) => element.data?.id === match.id || element.id === `rooms-${match.id}`,
  );
  return roomElement?.data ?? null;
};
